import { mutationOptions, queryOptions } from "@tanstack/react-query";
import { z } from "zod";
import { api } from "./apiClient";
import { FORMS_API_BASE_ENDPOINT } from "./constants";
import { queryClient } from "./queryClient";
import { ROLES, type Role } from "./users.types";

const BASE_ENDPOINT = `${FORMS_API_BASE_ENDPOINT}/admin/scimpermission`;

const scimPermissionsKeys = {
  all: () => ["scimPermissions"] as const,
} as const;

const ScimPermissionSchema = z.object({
  id: z.string(),
  organisationId: z.string(),
  tenantId: z.string(),
  role: z.enum(ROLES),
  adGroupIds: z.array(z.string()),
});

export type ScimPermission = z.infer<typeof ScimPermissionSchema>;

export const scimPermissionsQueryOptions = () =>
  queryOptions({
    queryKey: scimPermissionsKeys.all(),
    queryFn: () => api.get(BASE_ENDPOINT, { schema: z.array(ScimPermissionSchema) }),
    throwOnError: true,
  });

type SaveScimPermissionPayload = {
  permission: ScimPermission | undefined;
  tenantId: string;
  role: Role;
  adGroupIds: Array<string>;
};

export const saveScimPermissionMutationOptions = () =>
  mutationOptions({
    mutationFn: ({ permission, tenantId, role, adGroupIds }: SaveScimPermissionPayload) => {
      if (adGroupIds.length === 0 && permission) {
        return api.delete(`${BASE_ENDPOINT}/${permission.id}`);
      }
      if (!permission) {
        return api.post(BASE_ENDPOINT, { tenantId, role, adGroupIds });
      }
      return api.put(`${BASE_ENDPOINT}/${permission.id}`, { adGroupIds });
    },
    onSuccess: () => queryClient.invalidateQueries(),
  });
